import styles from './service.module.css'
export default function Serverpt(){
    return(
        <div style={{width: "80%", margin: "auto", paddingTop: '40px'}}>
        
        <div className={styles.cardContainer4}>

          <div className={styles.cardContainer3}>
            <div className={styles.cardTitle}>
            Server proqram təminatının quraşdırılması
            </div>
            <div className={styles.cartDesc}>
            •	Server əməliyyat sisteminin quraşdırılması və sazlanması <br/>
•	Terminal serverinin quraşdırılması və sazlanması <br/>
•	Virtual özəl şəbəkənin (VPN) quraşdırılması və sazlanması <br/>
•	Veb serverinin quraşdırılması və sazlanması <br/>
•	Verilənlər bazalarının idarəetmə sisteminin (DBMS) quraşdırılması və sazlanması <br/>
•	Məlumatların arxivləşdirmə sisteminin sazlanması


            </div>
          </div>

          <div className={styles.cardContainer3}>
            <div className={styles.cardTitle}>
            Ticarət avadanlığının quraşdırılması
            </div>
            <div className={styles.cartDesc}>
            •	Barkod oxuyucusunun quraşdırılması və sazlanması <br/>
•	Qəbz printerinin quraşdırılması və sazlanması <br/>
•	Fiskal qeydiyyatçısının quraşdırılması və sazlanması <br/>
•	Etiket printerinin quraşdırılması və sazlanması <br/>
•	Etiket çap edən tərəzinin quraşdırılması və sazlanması <br/>
•	Pul qabının quraşdırılması və sazlanması <br/>
•	Qiymət oxuyucusunun quraşdırılması və sazlanması <br/>
•	Sensorlu terminalın quraşdırılması və sazlanması <br/>
•	Əl terminalının quraşdırılması və sazlanması <br/>
•	Ekspeditor dəstinin quraşdırılması və sazlanması

            </div>
          </div>
          </div>

        </div>
    )
}